import type { ConfigurationContextValue } from "../root/ConfigurationContext";

// Labels of the services sold in a deal, joined for compact display.
export const dealServicesLabel = (
  services: string[] | null | undefined,
  dealCategories: ConfigurationContextValue["dealCategories"],
) =>
  (services ?? [])
    .map(
      (service) =>
        dealCategories.find((category) => category.value === service)?.label ??
        service,
    )
    .join(" · ");
